import { render, staticRenderFns } from "./CreditCardCharges.vue?vue&type=template&id=c2f52ed0&scoped=true"
import script from "./CreditCardCharges.vue?vue&type=script&lang=js"
export * from "./CreditCardCharges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f52ed0",
  null
  
)

export default component.exports